import {Catalog} from '../types/common';

export const getNumberRangeCatalog = (length: number): Catalog[] =>
    [...Array.from(Array(length))].map((_, item) => ({
        id: (item + 1).toString(),
        value: (item + 1).toString(),
    }));

export const mapCRLoanApplicationToDTO = data => ({
    ...data,
    home: !data.home ? undefined :
        Object
            .entries(data.home)
            .map(([k, v]) => {
                const responseKeyMap = {
                    holdTime: (k, v) => ['houseHoldTime', mapValueToCatalog(v)],
                    holdTimeMeasure: (k, v) => ['houseHoldMeasure', v],
                    houseType: (k, v) => ['houseType', v],
                    default: (k, v) => [k, v]
                };
                return (responseKeyMap[k] || responseKeyMap.default)(k, v);
            })
            .reduce((obj, [k, v]) => ({...obj, [k]: v}), {})
});
export const mapValueToCatalog = (value: number) => {
    const valueSting = value.toString();
    return {id: `${valueSting}`.slice(-2), value: valueSting} as Catalog;
};